import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox, CheckboxGroup, HStack, Input, InputGroup, NativeSelect, VStack, Field } from '@chakra-ui/react';
import { CurrencyInput } from '@src/components/sco/CurrencyInput';
import { HelpModal } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/HelpModal';
import { PitchBuidlerFormProps } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/index';
import { FUNDING_STAGES } from '@src/constants/funding-stages';
import React, { useState } from 'react';
export const FundingSection: React.FC<PitchBuidlerFormProps> = props => {
  const $ = _c(55);
  const [showHelpModal, setShowHelpModal] = React.useState(false);
  const [fundingGoalInDollars, setFundingGoalInDollars] = useState(props.investorSearch.fundingGoalInDollars);
  const [fundingGoalStageKey, setFundingGoalStageKey] = useState(props.investorSearch.fundingGoalStageKey);
  const [fundingGoalStructureKeys, setFundingGoalStructureKeys] = useState(props.investorSearch.fundingGoalStructureKeys);
  let t0;
  if ($[0] !== fundingGoalInDollars || $[1] !== fundingGoalStageKey || $[2] !== fundingGoalStructureKeys || $[3] !== props) {
    t0 = async t1 => {
      const next = t1 === undefined ? _temp : t1;
      if (!props.investorSearch.investorSearchId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertInvestorSearch({
        variables: {
          input: {
            investorSearchId: props.investorSearch.investorSearchId,
            fundingGoalInDollars,
            fundingGoalStageKey,
            fundingGoalStructureKeys
          }
        }
      });
      if (next) {
        next();
      }
    };
    $[0] = fundingGoalInDollars;
    $[1] = fundingGoalStageKey;
    $[2] = fundingGoalStructureKeys;
    $[3] = props;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const performSave = t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Field.Label>Funding Goal Amount</Field.Label>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== performSave) {
    t2 = ev => performSave();
    $[6] = performSave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value => setFundingGoalInDollars(value);
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2) {
    t4 = <CurrencyInput onBlur={t2} onNumericValueChange={t3} />;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== fundingGoalInDollars || $[12] !== t4) {
    t5 = <Field.Root>{t1}<InputGroup size="sm" startAddon="$"><Input asChild={true} numericValue={fundingGoalInDollars}>{t4}</Input></InputGroup></Field.Root>;
    $[11] = fundingGoalInDollars;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Field.Label>Fundraise Stage</Field.Label>;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== performSave) {
    t7 = ev_0 => performSave();
    $[15] = performSave;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t10;
  let t8;
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ev_1 => setFundingGoalStageKey(ev_1.target.value);
    t9 = <option>Select one...</option>;
    t10 = FUNDING_STAGES.map(_temp2);
    $[17] = t10;
    $[18] = t8;
    $[19] = t9;
  } else {
    t10 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t11;
  if ($[20] !== fundingGoalStageKey || $[21] !== t7) {
    t11 = <NativeSelect.Field minHeight="2.5em" size="sm" value={fundingGoalStageKey} onBlur={t7} onChange={t8}>{t9}{t10}</NativeSelect.Field>;
    $[20] = fundingGoalStageKey;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <NativeSelect.Indicator />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11) {
    t13 = <Field.Root>{t6}<NativeSelect.Root>{t11}{t12}</NativeSelect.Root></Field.Root>;
    $[24] = t11;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Field.Label>Structure</Field.Label>;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = values => setFundingGoalStructureKeys(values as string[]);
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      color: "white",
      fontSize: "12px"
    };
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Checkbox.HiddenInput />;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <label style={t16}><Checkbox.Root value="debt">{t17}<Checkbox.Control><Checkbox.Indicator /></Checkbox.Control></Checkbox.Root>  Debt/Loan</label>;
    t19 = {
      color: "white",
      fontSize: "12px"
    };
    $[30] = t18;
    $[31] = t19;
  } else {
    t18 = $[30];
    t19 = $[31];
  }
  let t20;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Checkbox.HiddenInput />;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  let t22;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <label style={t19}><Checkbox.Root value="convertible-note">{t20}<Checkbox.Control><Checkbox.Indicator /></Checkbox.Control></Checkbox.Root>  Convertible Note</label>;
    t22 = {
      color: "white",
      fontSize: "12px"
    };
    $[33] = t21;
    $[34] = t22;
  } else {
    t21 = $[33];
    t22 = $[34];
  }
  let t23;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Checkbox.HiddenInput />;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  let t25;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <label style={t22}><Checkbox.Root value="safe">{t23}<Checkbox.Control><Checkbox.Indicator /></Checkbox.Control></Checkbox.Root>  SAFE</label>;
    t25 = {
      color: "white",
      fontSize: "12px"
    };
    $[36] = t24;
    $[37] = t25;
  } else {
    t24 = $[36];
    t25 = $[37];
  }
  let t26;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Checkbox.HiddenInput />;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  let t27;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <HStack gap={6} marginTop={3}>{t18}{t21}{t24}<label style={t25}><Checkbox.Root value="equity">{t26}<Checkbox.Control><Checkbox.Indicator /></Checkbox.Control></Checkbox.Root>  Equity</label></HStack>;
    $[39] = t27;
  } else {
    t27 = $[39];
  }
  let t28;
  if ($[40] !== fundingGoalStructureKeys) {
    t28 = <Field.Root>{t14}<CheckboxGroup value={fundingGoalStructureKeys} onValueChange={t15}>{t27}</CheckboxGroup></Field.Root>;
    $[40] = fundingGoalStructureKeys;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== performSave || $[43] !== props) {
    t29 = <HStack justify="flex-end" padding={2} width="full"><Button size="xs" variant="cta" onClick={async () => {
        await performSave();
        props.onNextSection?.();
      }}>{"Save & Continue"}</Button></HStack>;
    $[42] = performSave;
    $[43] = props;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== t13 || $[46] !== t28 || $[47] !== t29 || $[48] !== t5) {
    t30 = <VStack align="stretch" gap={6} padding={4}>{t5}{t13}{t28}{t29}</VStack>;
    $[45] = t13;
    $[46] = t28;
    $[47] = t29;
    $[48] = t5;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== showHelpModal) {
    t31 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[50] = showHelpModal;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] !== t30 || $[53] !== t31) {
    t32 = <>{t30}{t31}</>;
    $[52] = t30;
    $[53] = t31;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  return t32;
};
function _temp() {}
function _temp2(stage) {
  return <option key={stage.key} value={stage.key}>{stage.title}</option>;
}